<!--
 * @Description: PC 端 轮播图 组件
-->
<template>
  <!-- 使用swiper -->
  <div class="mySwiper bg">

    <div class="mySwiper" v-if="coverImages.length === 0">
      <div class="empty-tips">
        直播即将开始！
      </div>
    </div>

    <div class="mySwiper" v-if="coverImages.length === 1">
      <div class="swiper-slide"  :style="{ backgroundImage: 'url(' + coverImages[0].url + ')' }"></div>
    </div>

    <swiper :options="swiperOption" class="mySwiper" v-if="coverImages.length > 1">
      <swiper-slide
        v-for="(item, index) in coverImages"
        :key="index"
        :style="{ backgroundImage: 'url(' + item.url + ')' }"
      >
        <!-- <img :src="item" alt="" class="swiper-lazy"> -->
      </swiper-slide>
      <!-- 这是轮播的小圆点 -->
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div> -->
      <div
        class="swiper-button-prev swiper-button-white"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next swiper-button-white"
        slot="button-next"
      ></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { mapState } from 'vuex'

export default {
  name: 'swiper-example',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {

      swiperOption: {
        notNextTick: true,
        initialSlide: 0, // 默认展示页
        pagination: {
          el: '.swiper-pagination',
          clickable: true, // 允许分页点击跳转
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        loop: true,
        touchRatio: 2, // 触摸滑动的顺畅度
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        speed: 500, // 播放速度
        // 滑动方向
        direction: 'horizontal',
        // 小手掌抓取滑动
        grabCursor: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        paginationClickable: true,
        spaceBetween: 15, // 模块之间的间隔
        // 修改swiper自己或子元素时，自动初始化swiper
        observer: true,
        // 修改swiper的父元素时，自动初始化swiper
        observeParents: true,
        on: {
          slideChangeTransitionEnd() {
            // 处理手动操作轮播图后后不再自动轮播
            this.autoplay.start()
          },
        },
      },
    }
  },

  computed: {
    ...mapState({
      // userInfo: state => state.player.userInfo,
      // liveInfo: state => state.player.liveInfo,
      coverImages: (state) => {
        if (
          state?.player?.liveInfo?.coverImages
          && state.player.liveInfo.coverImages.length > 0
        ) {
          // console.log(state.player.liveInfo.coverImages)
          return state.player.liveInfo.coverImages

          // return [{
          //   url: 'http://202.105.45.203:9080/storage/group1/M00/09/D0/CrEEwmRu20KAYPjOAABcJJG7czA776.jpg',
          //   name: '测试图片6.jpg',
          //   uid: 1684987306253,
          // }]
        }
        return []
      },
    }),
  },
  mounted() {
    // setTimeout(() => {
    //   this.advantageData = [
    //     'https://v1.github.surmon.me/images/example/1.jpg',
    //     'https://v1.github.surmon.me/images/example/2.jpg',
    //     'https://v1.github.surmon.me/images/example/3.jpg',
    //     'https://v1.github.surmon.me/images/example/4.jpg',
    //     'https://v1.github.surmon.me/images/example/5.jpg',
    //     'https://v1.github.surmon.me/images/example/6.jpg',
    //   ]
    // }, 200)
  },
}
</script>

<style lang="stylus">
:root:root {
  --swiper-theme-color: $highLightColor;
}
</style>

<style lang="stylus" scoped>
.mySwiper {
  height: 100%;
  width: 100%;

  &.bg{
    background-color: #030910
  }

  .empty-tips{
    color #fff
    font-size 2rem
    height: 100%;
    display flex
    align-items: center;
    justify-content: center;
  }

  .swiper-slide {
    display: flex;
    height: 100%;
    // background #444
    align-items: center;
    background-position: center;
    // background-size: cover;
    background-repeat: no-repeat;
    background-size: 100% auto;

    img {
      width: 100%;
    }
  }

  /deep/ .swiper-pagination{
    .swiper-pagination-bullet{
      opacity: .5;
      background: #fff;
    }

    .swiper-pagination-bullet-active {
        opacity: 1;
        background: var(--swiper-pagination-color, var(--swiper-theme-color));
    }
  }
}
</style>
